// Shop notice: alternates messages every few seconds. Pauses on hover/focus and in background tabs.
// With prefers-reduced-motion it never rotates (CSS shows all messages). Also exposes the notice height
// (--ll-shop-notice-height) so the header and the Shop toolbar stick right below it.
if (!customElements.get('ll-shop-notice')) {
  customElements.define(
    'll-shop-notice',
    class LaserlabShopNotice extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.ll-shop-notice__item'));
        this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
        this.delay = Math.max(4000, Number(this.dataset.interval) || 5000);
        this.hovered = false;
        this.focused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };

        this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
        this.addEventListener('focusout', () => { this.focused = false; this.start(); }, options);
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()), options);
        this.reducedMotion.addEventListener?.('change', () => this.start(), options);

        // The notice is sticky with the header, so its measured height is the offset for everything that sticks below it.
        const notice = this.closest('.ll-shop-notice') || this;
        const measure = () => {
          // Rounded down: the header (painted above the notice) may cover a fraction of a pixel, never leave a gap.
          const height = `${Math.floor(notice.getBoundingClientRect().height)}px`;
          document.documentElement.style.setProperty('--ll-shop-notice-height', height);
          document.documentElement.style.setProperty('--ll-shop-notice-offset', height);
        };
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(measure);
          this.resizeObserver.observe(notice);
        } else {
          window.addEventListener('resize', measure, { passive: true, signal: this.abort.signal });
        }
        measure();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        document.documentElement.style.removeProperty('--ll-shop-notice-offset');
        document.documentElement.style.removeProperty('--ll-shop-notice-height');
      }

      start() {
        this.stop();
        if (this.items.length < 2 || this.hovered || this.focused || document.hidden || this.reducedMotion.matches) return;
        this.timer = window.setInterval(() => this.next(), this.delay);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      next() {
        this.items[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }
    }
  );
}
